class DetailItem {
    constructor(_tab){
        this.tab = _tab;
    }

    getTempl(_newVal){
        return `
        <span class="gd-search-detail-tag">아이템 <span>DB</span></span>
        ${this.secHeaderTmpl(_newVal)}
        ${this.secOtionTmpl(_newVal)}
        ${this.secDescTmpl(_newVal)}
        ${this.secSetEffectTmpl(_newVal)}
        ${this.secEnchant(_newVal)}
        ${this.secKeepTypeTmpl(_newVal)}
        ${this.secEventsTmpl(_newVal)}`;
    }

    secHeaderTmpl(it){
        // let rareClass = (this.tab=='lineage2Awakening')? `rare-${it.nameClass}`: '';
        return `
        <div class="gd-search-detail-content">
            <span class="gd-detail-main-thumb"><img src="${it.image}" alt="${it.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')}" width="60" height="60" onerror="this.src='https://assets.playnccdn.com/plaync/gamedictionary/v1/img/default.png';"></span>
            <div class="gd-detail-main-text-wrap">
                <span class="gd-detail-main-text rare-${it.nameClass}">${it.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')} ${it.additionalName? ` <em>${it.additionalName} </em>`: ''}</span>
                <span class="gd-ico-item-grade gd-${it.grade.toLowerCase()}"></span>
                <span class="gd-detail-sub-text">${[it.weaponTypeName, it.slotTypeName].filter(tem=>!!tem).join(' / ')}</span>
            </div>
        </div>`;
    }

    secOtionTmpl(it){
        if(!(it.options?.length<1) && !it.weight) return '';
        return `
        <div class="gd-search-detail-content">
            <ul class="gd-detail-textinfo-list">
                ${it.options? `${it.options.map((opt)=>`<li>${opt.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')} : <em>${opt.value}</em></li>`).join('')}`: ``}
                ${it.weight? `<li>무게 : <em>${it.weight}</em></li>`: ``}
            </ul>
        </div>`;
    }

    secDescTmpl(it){
        if(!it.description) return '';
        return `
        <div class="gd-search-detail-content">
            <p class="gd-detail-info-paragraph">${it.description.replace(/\\n/g,'<br />')}</p>
        </div>`;
    }

    secSetEffectTmpl(it){
        if(!it.setItem) return '';

        let itemList = '';
        if (it.setItem.essentialSetItems) {
            itemList = it.setItem.essentialSetItems.map(itemIt=>{
                return `
                <li data-id="${itemIt.id}" data-name="${itemIt.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')}" data-image="${itemIt.image}">
                    <button>
                        <span class="gd-detail-imginfo-list-thumb"><img src="${itemIt.image}" alt="${itemIt.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')}" width="32" height="32" onerror="this.src='https://wstatic-cdn.plaync.com/plaync/gamedictionary/v1/img/default.png';"></span>
                        <span class="gd-detail-imginfo-list-text">${itemIt.additional?'<em>(+) </em>':''}${itemIt.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')}</span>
                    </button>
                </li>`;
            }).join('');
        }

        let pieceList = '';
        if (it.setItem.setItemDescriptions) {
            pieceList = it.setItem.setItemDescriptions.map((pieceIt)=>{
                return `<li>${pieceIt.piece}피스${ pieceIt.additional? ' + 쉴드': ''} : <em>${pieceIt.description}</em></li>`;
            }).join('');
        }

        let enchantInfo = '';
        if (it.setItem.enchantDescriptions) {
            enchantInfo = it.setItem.enchantDescriptions.map((enchantIt)=>enchantIt).join('<br />');
        }

        return `
        <div class="gd-search-detail-content">
            <strong class="gd-bold-text">세트효과</strong>
            <ul class="gd-detail-imginfo-list">${itemList}</ul>
            <ul class="gd-detail-textinfo-list">${pieceList}</ul>
            <p class="gd-detail-info-paragraph">${enchantInfo}</p>
        </div>`;
    }

    secEnchant(it){
        if (it.enchantOption?.enchant) {
            let itemList = it.enchantOption.enchant.map(enc=>{
                if (enc.condition===0 && enc.options?.length>0) {
                    return enc.options.map(ops=>{
                        return ops.description.map( desc=>{
                            return `<p class="gd-detail-info-paragraph">${desc.replace(/\\n/g,'<br />')}</p>`;
                        }).join('');
                    }).join('');
                }else{
                    return '';
                }
            }).join('');

            if (itemList) {
                return `
                <div class="gd-search-detail-content">
                    <strong class="gd-bold-text">인챈트 효과</strong>
                    ${itemList}
                </div>`;
            }else{
                return '';
            } 
        } else{
            return '';
        } 
    }

    secKeepTypeTmpl(it){
        let obj = {
            tradable:'교환',
            dropable:'드롭',
            crushable:'파쇄',
            personalStorable:'개인상점',
            npcTradable:'상점판매'
        };

        let impossibleStr = '';
        let impossibleList = [];
        Object.keys(obj).forEach( (key)=>{
            if (!it[key]) {
                impossibleList.push(obj[key]);
            }
        });
        if (it.unCommissionable) {
            impossibleList.push('판매대행');
        }
        if (impossibleList.length>0) {
            impossibleStr = impossibleList.join('/') + ' 이용 불가.';
        }

        if(!it.keepTypeDescription && !impossibleStr) return '';
        return `
        <div class="gd-search-detail-content">
            <p class="gd-detail-info-paragraph gd-font-impassible">${it.keepTypeDescription}</p>
            <p class="gd-detail-info-paragraph gd-font-impassible">${impossibleStr}</p>
        </div>`;
    }

    secEventsTmpl(it){
        if(!it.eventInfo || it.eventInfo.length<1) return '';
        let eventList = it.eventInfo.map(eveIt=>{
            return `
            <div class="gd-event-info-wrap">
                <span class="gd-event-thumb"><img src="${eveIt.thumbnailUrl}" alt="${eveIt.title}""></span>
                <div class="gd-event-info">
                    <span class="gd-event-info-text">${eveIt.title}</span>
                    <span class="gd-event-info-text">${eveIt.description}</span>
                </div>
        </div>`;
        }).join('');
        return `
        <div class="gd-search-detail-content">
            <strong class="gd-bold-text">관련 이벤트</strong>
            ${eventList}
        </div>`;
    }

} // end of class
export default DetailItem;